module.exports = __webpack_public_path__ + "static/media/img0012.9fecfe7a.jpg";